import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.subsecai.com';

/** In-app documentation route (SPA). Do not use bare origin — that reloads home with no docs. */
export const DOCS_PATH = '/docs';
export const DOCS_URL = DOCS_PATH;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// Avoid appending a timestamp to every request — it defeats HTTP caching and CDN reuse.

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err.response?.data?.detail || '';

    // Deactivated user — force logout
    if (err.response?.status === 403 && detail.includes('deactivated')) {
      document.cookie = 'access_token=; Max-Age=0; path=/';
      window.location.href = '/login';
    }

    if (err.config?.url?.includes('/api/auth/me') && err.response?.status === 401) {
      err.suppressLog = true;
    }
    return Promise.reject(err);
  }
);

export default api;
